import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CohortDO } from '../domain-model-dtos';

@Injectable()
export class AdminContextService {
  public static COHORT_LOCAL_STORAGE_KEY = 'cohort';
  private static readonly FIXED_COHORT_ID = 1;

  private cohorts: CohortDO[];

  private cohortSubject: Subject<CohortDO> = new BehaviorSubject<CohortDO>(undefined);

  public getCohortWatcher() {
    return this.cohortSubject.asObservable();
  }

  setCohort(_cohort: CohortDO) {
    this.applyFixedCohort();
  }

  setCohortId(_cohortId: number) {
    this.applyFixedCohort();
  }

  initialize(cohorts: CohortDO[]) {
    if (cohorts) {
      this.cohorts = cohorts;
      this.applyFixedCohort();
    }
  }

  private applyFixedCohort() {
    const cohort = this.getFixedCohort();
    if (cohort) {
      this.cohortSubject.next(cohort);
      localStorage.setItem(AdminContextService.COHORT_LOCAL_STORAGE_KEY, cohort.id.toString());
    }
  }

  private getFixedCohort(): CohortDO {
    return this.cohorts?.find((t) => t.id === AdminContextService.FIXED_COHORT_ID) || this.defaultCohort();
  }

  private defaultCohort(): CohortDO {
    return this.cohorts?.find((t) => t.id === AdminContextService.FIXED_COHORT_ID) || this.cohorts?.[0];
  }

  getCohortIcon(cohortId: number): string {
    return this.cohorts.find((c) => c.id === cohortId).icon;
  }
}
